import * as React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { TableCell } from '@mui/material';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface TableHeaderCellProps {
  content: string | null;
  sort?: boolean;
  setSortType?: any;
  sortType?: string;
  smallFont?: boolean;
  sticky?: boolean;
  pinRight?: boolean;
  rightOffset?: string;
  isNotCapitalize?: boolean;
  leftSticky?: boolean;
  leftSticky2?: boolean;
  className?: string;
  width?: string;
  justifyContent?: boolean;
  paddingLeft?: any;
  colSpan?: number | null;
  totalColumnStyle?:boolean
}

export const TableHeaderCell: React.FC<TableHeaderCellProps> = (prop) => {
  return (
    <TableCell
      colSpan={prop?.colSpan ? prop?.colSpan : 0}
      className={prop.className ? prop.className : ''}
      style={{
        whiteSpace: 'nowrap',
        alignItems: 'center',
        color: '#232C68',
        fontWeight:`${ prop.totalColumnStyle ? '900' :'700'}`,
        fontSize: `${prop.smallFont ? '11px' : ''}`,
        position: `${prop.sticky || prop.pinRight || prop.rightOffset || prop.leftSticky || prop.leftSticky2 ? 'sticky' : 'relative'}`,
        right: `${prop.rightOffset ? prop.rightOffset : prop.sticky || prop.pinRight ? 0 : ''}`,
        zIndex: `${prop.rightOffset ? 890 : prop.sticky || prop.pinRight || prop.leftSticky || prop.leftSticky2 ? 900 : ''}`,
        padding: `${prop.sticky || prop.pinRight || prop.rightOffset ? '0' : ''}`,
        borderLeft: `${prop.sticky || prop.pinRight || prop.rightOffset ? '1px solid #dce6f1' : ''}`,
        borderRight: `${prop.leftSticky || prop.leftSticky2  ? '1px solid #dce6f1' : ''}`,
        left: `${prop.pinRight || prop.rightOffset ? 'auto' : prop.sticky ? 0 : prop.leftSticky ? '100px' : prop.leftSticky2 ? '60px' : ''}`,
        width: prop.pinRight || prop.rightOffset ? prop.width : undefined,
        minWidth: prop.pinRight || prop.rightOffset ? prop.width : undefined,
        maxWidth: prop.pinRight || prop.rightOffset ? prop.width : undefined,
        boxSizing: 'border-box',
        background: `${ prop.totalColumnStyle ? 'rgba(98, 103, 253, 0.2)': '#E6E9FF'}`,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', width: prop.pinRight || prop.rightOffset ? '100%' : prop?.width, justifyContent: prop?.justifyContent ? 'center' : 'unset', paddingLeft: prop?.paddingLeft ? prop?.paddingLeft : 0}}>
        <div
          style={{
            background: 'inherit',
            paddingRight: `${prop.sticky || prop.pinRight ? '0.5rem' : ''}`,
            paddingLeft: `${prop.sticky || prop.pinRight ? '0.5rem' : ''}`,
            textTransform: prop.isNotCapitalize ? 'none' : 'capitalize',
            fontWeight:'inherit'
          }}
        >
          {prop.content}
        </div>

        {prop.sort && (
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              marginTop: '-0.2em'
            }}
            onClick={() =>
              prop.setSortType(prop.sortType === 'asc' ? 'desc' : 'asc')
            }
          >
            <ArrowDropUpIcon
              sx={{
                marginLeft: '4px !important',
                fontSize: '20px !important',
                color: 'rgb(35, 44, 104) !important',
                cursor: 'pointer !important',
                marginBottom: '-0.35rem !important',
                width: '0.8em !important',
                height: 'unset !important'
              }}
            />
            <ArrowDropDownIcon
              sx={{
                marginLeft: '4px !important',
                fontSize: '20px !important',
                color: 'rgb(35, 44, 104) !important',
                cursor: 'pointer !important',
                marginBottom: '-0.35rem !important',
                width: '0.8em !important',
                height: 'unset !important'
              }}
            />
          </span>
        )}
      </div>
    </TableCell>
  );
};
